(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ========== Scroll reveal ========== */
  const revealEls = document.querySelectorAll('.woofy-reveal');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  }

  /* ========== Letter-by-letter heading ========== */
  document.querySelectorAll('[data-woofy-letter-reveal]').forEach((node) => {
    const text = node.textContent;
    node.textContent = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.className = 'woofy-letter';
      span.textContent = ch === ' ' ? ' ' : ch;
      span.style.transitionDelay = (60 + i * 36) + 'ms';
      node.appendChild(span);
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          node.querySelectorAll('.woofy-letter').forEach((s) => s.classList.add('is-visible'));
          io.unobserve(node);
        }
      });
    }, { threshold: 0.2 });
    io.observe(node);
  });

  /* ========== Animated counters ========== */
  document.querySelectorAll('[data-woofy-counter]').forEach((node) => {
    const target = parseFloat(node.dataset.woofyCounter);
    const suffix = node.dataset.woofyCounterSuffix || '';
    const duration = parseInt(node.dataset.woofyCounterDuration || '1600', 10);
    let started = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started) {
          started = true;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            const value = target * eased;
            node.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
            if (p < 1) requestAnimationFrame(tick);
            else node.textContent = target + suffix;
          };
          requestAnimationFrame(tick);
          io.unobserve(node);
        }
      });
    }, { threshold: 0.4 });
    io.observe(node);
  });

  /* ========== Mega nav ========== */
  const nav = document.querySelector('[data-woofy-nav]');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 8) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    nav.querySelectorAll('[data-woofy-mega-toggle]').forEach((btn) => {
      const li = btn.closest('li');
      const close = () => li.classList.remove('is-open');
      const open = () => li.classList.add('is-open');
      let timer;
      li.addEventListener('mouseenter', () => { clearTimeout(timer); open(); });
      li.addEventListener('mouseleave', () => { timer = setTimeout(close, 150); });
      btn.addEventListener('focus', open);
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { close(); btn.blur(); }
      });
      document.addEventListener('click', (e) => {
        if (!li.contains(e.target)) close();
      });
    });
  }

  /* ========== Parallax hero image ========== */
  document.querySelectorAll('[data-woofy-parallax]').forEach((el) => {
    const speed = parseFloat(el.dataset.woofyParallax || '0.18');
    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const offset = (rect.top * -1) * speed;
        el.style.transform = 'translate3d(0,' + offset + 'px,0) scale(1.06)';
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
